module.exports = __webpack_public_path__ + "static/media/chat-w.f9a5a514.svg";